"use client";
import React, { useState } from "react";
import { Modal, Form, Icon } from "semantic-ui-react";
import { ButtonItem, Field } from "../../components"; // Update path as needed
import { sendAgentContatEmail } from "../../modules/Graphql/notificationgraphql";

const AgentContact = ({ open, onClose, neighborhoodname }) => {
  const [formData, setFormData] = useState({
    f_name: "",
    c_email: "",
    c_phone: "",
    c_message: "",
  });

  const [sending, setSending] = useState(false);
  const [mailsuccess, setMailsuccess] = useState("");
  const [formKey, setFormKey] = useState(Date.now());

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMailsuccess("");
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      f_name: "",
      c_email: "",
      c_phone: "",
      c_message: "",
    });
    setFormKey(Date.now());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMailsuccess("");
    setSending(true);

    try {
      const noti_data = {
        name: formData.f_name.trim() || "NA",
        email: formData.c_email.trim() || "NA",
        phone: formData.c_phone.trim() || "NA",
        message: formData.c_message.trim() || "NA",
        neighborhoodname: neighborhoodname || "NA",
      };

      await sendAgentContatEmail(noti_data);
      setMailsuccess("true");
      resetForm(); // clears input
    } catch (error) {
      setMailsuccess("false");
    } finally {
      setSending(false);
    }
  };

  const handleClose = () => {
    resetForm();
    onClose();
    setMailsuccess("");
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      size="tiny"
      closeOnDimmerClick={!sending}
    >
      <Modal.Header>
        Contact Us
        <Icon
          name="close"
          onClick={handleClose}
          style={{ float: "right", cursor: "pointer" }}
        />
      </Modal.Header>

      <Modal.Content>
        {mailsuccess === "true" ? (
          <p
            className="contact_success"
            style={{ color: "green", marginTop: 10, textAlign: "center" }}
          >
            Thank you for contacting us. We'll get back to you shortly.
          </p>
        ) : (
          <Form key={formKey}>
            <Form.Field>
              <label>Name</label>
              <Field
                contrl="Input"
                name="f_name"
                value={formData.f_name}
                placeholder="Your Name"
                onChange={handleChange}
              />
            </Form.Field>

            <Form.Field>
              <label>Email</label>
              <Field
                contrl="Input"
                name="c_email"
                value={formData.c_email}
                placeholder="Your Email"
                onChange={handleChange}
              />
            </Form.Field>

            <Form.Field>
              <label>Phone Number</label>
              <Field
                contrl="Input"
                name="c_phone"
                value={formData.c_phone}
                placeholder="Your Phone"
                onChange={handleChange}
              />
            </Form.Field>

            <Form.Field>
              <label>Message</label>
              <Field
                contrl="textarea"
                name="c_message"
                value={formData.c_message}
                placeholder="Your Message"
                onChange={handleChange}
                className="text_area_cnt"
              />
            </Form.Field>

            <div style={{ marginTop: "16px" }}>
              <ButtonItem
                fluid
                primary
                title={sending ? "Sending..." : "Send"}
                onClick={handleSubmit}
                disabled={sending}
                style={{ cursor: sending ? "not-allowed" : "pointer" }}
                className="contact_send"
              />
            </div>

            {mailsuccess === "false" && (
              <p
                className="contact_error"
                style={{ color: "#c02e26", marginTop: 10 }}
              >
                Something went wrong. Please try again later.
              </p>
            )}
          </Form>
        )}
      </Modal.Content>
    </Modal>
  );
};

export default AgentContact;
